import styled from "styled-components";
import MaterialItem from "./MaterialItem";
import {ConfigurateurContext} from "../../context/context";
import {device, TYPE_DECOUPE, TYPE_PLIAGE} from "../../helper/constants";
import {DECOUPE_FORMS, MATERIAL_SHADES, MATERIAL_THICKNESS, PLIAGE_FORMS} from "../../helper/materials";
import ShadeItem from "./ShadeItem";
import ThicknessItem from "./ThicknessItem";
import axios from "axios";
import { Tooltip } from 'react-tooltip'
import CommandTypeItem from "./CommandTypeItem";
import DecoupeFormItem from "./DecoupeFormItem";
import PliageFormItem from "./PliageFormItem";
import DimensionContainer from "./DimensionContainer";
import CommandStepContainer from "./CommandStepContainer";
import {getFormFromMid, getMaterialAndShadeFromCurrentPath} from "../../helper/function";
const {
    element: {
        useContext,
    },
} = wp;

const Wrapper = styled.div`
    width: 100%;
    padding: 30px;
    background-color: #fff;
    min-height: 150px;
    justify-content: center;
    display: flex;
  
    &.hjt-modal {
      flex-direction: column;
      align-items: center;
    }
    @media ${device.mobile} {
        padding: 0;
        height: calc(100vh - 265px);
        overflow: scroll;
        display: block;
    }
    @media ${device.tablet} {
        padding: 0;
    }
`;

const ListContainer = styled.div`
    display: flex;
    gap: 10px;
    flex-direction: column;
    justify-content: start;
    position: relative;
    padding: 10px;
    width: 100%;
  
    &.w-50 {
      width: 50%;
    }
    & p {
        font-size: 18px;
        font-weight: bold;
        color: #144344;
    }
    @media ${device.mobile} {
        &.w-50 {
          width: 100%;
        }
        justify-content: center;
    }
`;

const MyContainer = styled.div`
    display: flex;
    width: 50%;
    flex-direction: row;
    justify-content: center;
    @media ${device.mobile} {
        width: 100%;
        flex-direction: column;
    }
`;

const SectionLabel = styled.p`
   text-align: center;
    margin-bottom: 0 !important;
`;

const MaterialList = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
`;

const MaterialListStretch = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
  gap: 10px;
  flex-wrap: wrap;
`;

const CommandTypeWrap = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  gap: 30px;
`;

export default function StepBody({handleSelect, mode}) {

    const {
        currentStep,
        currentMaterial,
        currentShade,
        type,
        thickness,
        form,
        dimensions,
    } = useContext(ConfigurateurContext);

    const currentPath = window.location.pathname;

    const {materiel} = getMaterialAndShadeFromCurrentPath(currentPath);

    let formsFromMid = getFormFromMid(currentMaterial);

    console.log(materiel);

    return (
        <>
            {currentStep === 1 && (
                <Wrapper className={mode === 'modal' ? 'hjt-modal' : ''}>
                    <MyContainer>
                        { (materiel === 'metal' || currentPath === '/') ? (
                            <ListContainer className={currentPath === '/' ? "w-50" : ""}>
                                <SectionLabel>Métal</SectionLabel>
                                <MaterialList>
                                    <MaterialItem mid={'acier'} handleSelect={handleSelect} />
                                    <MaterialItem mid={'inox'} handleSelect={handleSelect}/>
                                    <MaterialItem mid={'aluminium'} handleSelect={handleSelect}/>
                                    <MaterialItem mid={'laiton'} handleSelect={handleSelect}/>
                                </MaterialList>
                            </ListContainer>
                        ) : ''}

                        { (materiel === 'bois' || currentPath === '/') ? (
                            <ListContainer className={currentPath === '/' ? "w-50" : ""}>
                                <SectionLabel>Panneau Bois</SectionLabel>
                                <MaterialList>
                                    <MaterialItem mid={'bois-brut'} handleSelect={handleSelect} />
                                    <MaterialItem mid={'melamine'} handleSelect={handleSelect} />
                                </MaterialList>
                            </ListContainer>
                        ) : ''}
                    </MyContainer>
                    <MyContainer>
                        { (materiel === 'plexi' || currentPath === '/') ? (
                            <ListContainer className={currentPath === '/' ? "w-50" : ""}>
                                <SectionLabel>Plexi</SectionLabel>
                                <MaterialList>
                                    <MaterialItem mid={'plexi-pmma'} handleSelect={handleSelect}/>
                                    <MaterialItem mid={'plexi-polycarbonate'} handleSelect={handleSelect}/>
                                </MaterialList>
                            </ListContainer>
                        ) : ''}

                        { (materiel === 'miroir-et-verre-old' || currentPath === '/old') ? (
                            <ListContainer className={currentPath === '/' ? "w-50" : ""}>
                                <SectionLabel>Miroir & verre</SectionLabel>
                                <MaterialList>
                                    <MaterialItem mid={'miroir'} handleSelect={handleSelect}/>
                                    <MaterialItem mid={'verre'} handleSelect={handleSelect}/>
                                </MaterialList>
                            </ListContainer>
                        ) : '' }
                    </MyContainer>
                </Wrapper>
            )}
            {currentStep === 2 && currentMaterial !== null && (
                <Wrapper>
                    <ListContainer style={{marginTop: "10px"}}>
                        <MaterialList>
                            {
                                Object.values(MATERIAL_SHADES[currentMaterial]).map(item => {
                                    return <ShadeItem mid={item.mid} imageUrl={item.image} label={item.label} subLabel={item.subLabel}  handleSelect={handleSelect} />
                                })
                            }
                        </MaterialList>
                    </ListContainer>
                </Wrapper>
            )}

            {currentStep === 3 && (
                <Wrapper>
                    <ListContainer style={{marginTop: "10px", width: "100%"}}>
                        <CommandTypeWrap>
                            <CommandTypeItem title={"Voulez-vous découper ?"} imageUrl={"/wp-content/uploads/2023/09/decoupage.png"} mType={TYPE_DECOUPE}  handleSelect={handleSelect}/>
                            <CommandTypeItem title={"Ou plier votre pièce ?"} imageUrl={"/wp-content/uploads/2023/09/pliage.png"} mType={TYPE_PLIAGE}  handleSelect={handleSelect}/>
                        </CommandTypeWrap>
                    </ListContainer>
                </Wrapper>
            )}
            {currentStep === 4 && currentMaterial !== null && currentShade &&(
                <Wrapper>
                    <ListContainer style={{marginTop: "10px"}}>
                        <MaterialListStretch>
                            {
                                MATERIAL_THICKNESS[currentShade].map(value => {
                                    return <ThicknessItem value={value} handleSelect={handleSelect}/>
                                })
                            }
                        </MaterialListStretch>
                    </ListContainer>
                </Wrapper>
            )}
            {currentStep === 5 && currentMaterial !== null && thickness !== null && (
                <Wrapper>
                    <ListContainer style={{marginTop: "10px"}}>
                        <MaterialListStretch>
                            {
                                type === TYPE_DECOUPE && Object.values(formsFromMid).map((item) => {
                                    return <DecoupeFormItem formData={item} handleSelect={handleSelect}/>
                                })
                            }
                            {
                                type === TYPE_PLIAGE && Object.values(PLIAGE_FORMS).map((item) => {
                                    return <PliageFormItem formData={item} handleSelect={handleSelect}/>
                                })
                            }
                        </MaterialListStretch>
                    </ListContainer>
                </Wrapper>
            )}
            {currentStep === 6 && form !== null && (
                <Wrapper>
                    <DimensionContainer fid={form} type={type} material={currentMaterial} shade={currentShade}/>
                </Wrapper>
            )}
            {currentStep === 7 &&  dimensions !== null && (
                <Wrapper>
                    <CommandStepContainer fid={form} type={type} material={currentMaterial} shade={currentShade}/>
                </Wrapper>
            )}
        </>
    )
}